import apiClient from '../../../lib/client';

/**
 * User profile API functions
 */

export const usersAPI = {
  // Get current user profile
  getCurrentUser: async () => {
    const { data } = await apiClient.get('/users/me');
    return data;
  },

  // Update user profile
  updateProfile: async (updates) => {
    const { data } = await apiClient.patch('/users/me', updates);
    return data;
  },

  // Delete account
  deleteAccount: async (password) => {
    const { data } = await apiClient.delete('/users/me', {
      data: { password },
    });
    return data;
  },

  // Export user data (GDPR)
  exportData: async () => {
    const { data } = await apiClient.get('/users/me/export');
    return data;
  },
};
